import { Flex, Space } from 'antd'
import { FunctionComponent, useState } from 'react'
import {
  ResetPasswordForm,
  ResetPasswordFormValues,
} from '@/components/form/reset-password-form'
import RWDCardLayout, {
  COMMON_DESKTOP_CARD_BODY_WIDTH,
  CommonCardDescription,
  CommonCardTitle,
} from '@/components/layout/rwd-card-layout'
import { useIntl } from '@/i18n/hooks/use-intl'
import { toVoidFunction } from '@/utils/to-void-function'

type ResetPasswordViewProps = {
  onFinish(values: ResetPasswordFormValues): Promise<void>
}

const ResetPasswordView: FunctionComponent<ResetPasswordViewProps> = ({
  onFinish,
}) => {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState<boolean>(false)

  const handleFinish = async (
    values: ResetPasswordFormValues,
  ): Promise<void> => {
    try {
      setLoading(true)
      await onFinish(values)
    } catch {
    } finally {
      setLoading(false)
    }
  }

  return (
    <RWDCardLayout cardBodyWidth={COMMON_DESKTOP_CARD_BODY_WIDTH}>
      <Flex gap={32} vertical={true}>
        <Space
          align='center'
          direction='vertical'
          size={12}
          style={{ width: '100%' }}
        >
          <CommonCardTitle>
            {formatMessage({ id: 'account:forget_password_page_title' })}
          </CommonCardTitle>
          <CommonCardDescription>
            {formatMessage({ id: 'account:forget_section_title' })}
          </CommonCardDescription>
        </Space>
        <ResetPasswordForm
          loading={loading}
          onFinish={toVoidFunction(handleFinish)}
        />
      </Flex>
    </RWDCardLayout>
  )
}

export default ResetPasswordView
